import { Action } from '@ngrx/store';
import { YourLumpSumAllowances } from 'src/app/model/ngrx/your-lump-sum-allowances.model';
 
import * as YourLumpSumAllowance from './../actions/your-lump-sum-allowances.actions';

export type Actions = YourLumpSumAllowance.Actions;

const initialState: YourLumpSumAllowances = {
    lsaQuestion: '',
    lsDbaQuestion: '',
    lsaLgaProtectionQuestion: '',
    protectionType: '',
    riskAndStaticQuestion : []
};


export function YourLumpSumAllowancesReducer(state: YourLumpSumAllowances[] = [initialState], action: YourLumpSumAllowance.Actions) {
    switch (action.type) {
        case YourLumpSumAllowance.ADD_YOUR_LUMP_SUM_ALLOWANCES:
            return [...state, action.payload];

        case YourLumpSumAllowance.REMOVE_YOUR_LUMP_SUM_ALLOWANCES:
            state = [];
            return state; // [...state].splice(action.payload, 1);

        default:
            return state;
    }
}
